import React from "react";
import { X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import Spinner from "../../../common/Spinner/Spinner";
import NeftModal from "../Handholder/NeftModal";
import moment from "moment";

import ConfirmationModal from "./ConfirmationModal";
import RefundModal from "./RefundModal";
import StateChangeLogModalSPM from "./StateChangeLogModalSPM";
import copysvg from "./../../../assets/arrow_copy.svg"
import { toast } from "react-toastify";

export default function StateServiceChangeModalSPM(props) {

// updated by column 

	const renderStateChangeAuditLog = () => {
		if (props.stateAuditLog) {
			let rows = props.stateAuditLog.map((e) => {
				return (
					<tr className="trs">
						<td className="tdss">{e["refCurrentState"]}</td>
						<td className="tdss">
							{moment(moment.utc(e["dtCreated"]).toDate()).format(
								"Do MMMM YYYY, h:mm:ss a"
							)}
						</td>
						<td className="tdss">{e["reqUser"]}</td>
					</tr>
				);
			});
			return (
				<table className="tablescss">			
				{/* <tr className="ths"> */}
					<th className="ths">Current State</th>
					<th className="ths">Date</th>
					<th className="ths">Updated by</th>
				{/* </tr> */}
					{rows}
				</table>

				
				// conv-border-top-right
			);
		} else return "Status log not available for this service request";
	
		 
	};

	const copyToClipboard = (content) => {
        const el = document.createElement('textarea');
        el.value = content;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };

	
	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
			className="conv-mt40"
		>
			
			<ModalContent className={`${props?.service?.urlPayment ? "spmStatusModal" : ""}`}>
			<div className="col-12"> 
			    <div className="row">
					<div className="col-12 conv-pl0 conv-pr0">
					<div className={`p-2 modal-headers-bar`}>
							<span>Status</span>
							<button
								type="button"
								className="close"
								aria-label="Close"
								onClick={props.toggleModal}
							>
								<X
									style={{ pointerEvents: "none" }}
									color="white"
								/>
							</button>
						</div>
					</div>
				  <div className="col-4 borderright"> 
				  	{props.service ? console.log("props.service=",props.service) : console.log('empty')}
				    {props.service ? (
					<div className={`status-column`}>
						<span className="spled-info-title">Update Status</span>
						{props.isLoading && <Spinner className=" center" />}

						
						<div
							className={`${
								props.service["sDeliveryMods"] === "Self-Served"
									? "disable-modal"
									: ""
							}   ${props.isLoading && "set-opacity"} `}
						>
							
							<label
								className={`container1 ${props.service.statusArray[0]}`}
							>
								Ready for progression
								<input
									name="readyForProgression"
									onClick={(f) =>
										props.handleClick(f, props.service)
									}
									type="checkbox"
									checked="checked"
								></input>
								<span
									name="readyForProgression"
									onClick={(f) =>
										props.handleClick(f, props.service)
									}
									className={`checkmark ${props.service.statusArray[0]}`}
								></span>
							</label>
							<label
								class={`container1 ${props.service.statusArray[1]}`}
							>
								Awaiting For Information/Documents
								<input
									name="AwaitingForInformationDocuments"
									onClick={(f) =>
										props.handleClick(f, props.service)
									}
									type="checkbox"
									checked="checked"
								></input>
								<span
									name="AwaitingForInformationDocuments"
									onClick={(f) =>
										props.handleClick(f, props.service)
									}
									class={`checkmark ${props.service.statusArray[1]}`}
								></span>
							</label>
							<label
								class={`container1 ${props.service.statusArray[2]}`}
							>
								Info and Docs Received
								<input
									name="InfoandDocsReceived"
									onClick={(f) =>
										props.handleClick(f, props.service)
									}
									type="checkbox"
									checked="checked"
								></input>
								<span
									name="InfoandDocsReceived"
									onClick={(f) =>
										props.handleClick(f, props.service)
									}
									class={`checkmark ${props.service.statusArray[2]}`}
								></span>
							</label>
							<label
								class={`container1 ${props.service.statusArray[3]}`}
							>
								Payment Confirmed By Partner
								<input
									name="paymentConfirmedByPartner"
									onClick={(f) =>
										props.handleClick(f, props.service)
									}
									type="checkbox"
									checked="checked"
								></input>
								<span
									name="paymentConfirmedByPartner"
									onClick={(f) =>
										props.handleClick(f, props.service)
									}
									class={`checkmark ${props.service.statusArray[3]}`}
								></span>
							</label>
							<label
								class={`container1 ${props.service.statusArray[4]}`}
							>
								Service Delivery Started
								<input
									name="serviceDeliveryStarted"
									onClick={(f) =>
										props.service.statusArray[4] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									type="checkbox"
								></input>
								<span
									name="serviceDeliveryStarted"
									onClick={(f) =>
										props.service.statusArray[4] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									class={`checkmark ${props.service.statusArray[4]}`}
								></span>
							</label>


							<label
								class={`container1 ${props.service.statusArray[5]}`}
							>
								Service Deliverables Ready
								<input
									name="serviceDeliverablesReady"
									onClick={(f) =>
										props.service.statusArray[5] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									type="checkbox"
								></input>
								<span
									name="serviceDeliverablesReady"
									onClick={(f) =>
										props.service.statusArray[5] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									class={`checkmark ${props.service.statusArray[5]}`}
								></span>
							</label>
{/* 
							${
										props.service["sPaymentMode"] ===
										"2_Step_Payment"
											? ""
											: "disabled"
									}  */}
									

							<div class="payment-links">
								<div
									style={{
										display: "flex",
									}}
								 >

									<div
									className={`underlined-action  ${
										props.service["nPackageInstanceId"] 
											?
											 "disabled"
											: props.service["nPackageInstanceId"] == null 
											&&	(props.service['sPaymentReceiver'] !== "Partner" || props.service['sPaymentReceiver'] === "Partner" && props?.service['refExternalServicePartner']?.id === 66) && props.service["sPaymentMode"] ===
											"2_Step_Payment" ?
											props.service?.bCouponApplied && (props.service.fDiscountAmount + (props.service.fDiscountAmount * 0.18)) >= props.service.fAmountFirst ?
											"disabled"
											:
											""
											:
											"disabled"
									}
									${props.service["refCurrentState"][
										"sServiceState"
									] === "Service deliverables ready" || props.service["refCurrentState"][
										"sServiceState"
									] === "Full Payment Requested" ?  "" : "disable"}`}
									onClick={(f) =>
										props.toggleNeftModal(props.service)
									}
									>
										{/* <span className="label-link">
										{props.service["refCurrentState"][
										"sServiceState"
									] === "Full Payment Requested"
										? "View NEFT Details"
										: "Add NEFT Details"}
									</span> */}
									<span className="label-link">
										{/* {props.service["refCurrentState"][
										"sServiceState"
									] === "Full Payment Requested"
										? "View NEFT Details"
										: "Add NEFT Details"} */}
										{props.service["bNEFTPayment"] && (props.service?.sNEFTDetails || props.service?.sNEFTTxnId_2)
										? "View NEFT Details"
										: "Add NEFT Details"}
									</span>
										
									</div>


									<div
										className={`underlined-action ${
											props.service["nPackageInstanceId"]
												?
												 "disabled"
												: props.service["nPackageInstanceId"] == null 
												&& (props.service['sPaymentReceiver'] !== "Partner" || props.service['sPaymentReceiver'] === "Partner" && props?.service['refExternalServicePartner']?.id === 66) && props.service["sPaymentMode"] ===
												"2_Step_Payment" ?
												props.service?.bCouponApplied && (props.service.fDiscountAmount + (props.service.fDiscountAmount * 0.18)) >= props.service.fAmountFirst ?
											  	"disabled"
											  	:
												""
												:
												"disabled"
										}${
											props.service["sPaymentStatus"] ===
											"Credit"
												? "disabled"
												: ""
										} ${props.service["refCurrentState"][
											"sServiceState"
										] === "Service deliverables ready" || props.service["refCurrentState"][
											"sServiceState"
										] === "Full Payment Requested" ?  "" : "disable"}`}
										onClick={(f) =>
											props.sendPaymentLink(props.service)
										}
									>
										<span className="label-link">Send Payment Link</span>
										
									</div>


									{/* <div
										className={`underlined-action ${
											
											props.service["sPaymentStatus"] ===
											null
												? props.service[
														"urlPayment"
												  ] !== null
													? "PaymentPending"
													: "NotSent"
												: props.service[
														"sPaymentStatus"
												  ] === "Credit"
												? "PaymentReceived"
												: "PaymentFailed"
										} ${
											props.service["sPaymentMode"] ===
											"2_Step_Payment"
												? ""
												: "disabled"
										} ${
											props.service["sPaymentStatus"] ===
											"Credit"
												? "disabled"
												: ""
										}
                     `}
									>
										<small className="label-link">
											<label className="label-link">
												{props.service[
													"sPaymentStatus"
												] === null
													? props.service[
															"urlPayment"
													  ] !== null
														? "Payment Pending"
														: "Not Sent"
													: props.service[
															"sPaymentStatus"
													  ] === "Credit"
													? "Payment Received"
													: props.service[
															"sPaymentStatus"
													  ] === "Failed"
													? "Payment Failed"
													: "Payment Link Deactivated"}
											</label>
										</small>
									</div> */}
									{/* <div
										className={`underlined-action ${
											
											props.service["sPaymentStatus"] ===
											null || props.service["urlPayment"] == null
												? props.service[
														"urlPayment"
												  ] !== null
													? "PaymentPending"
													: "NotSent"
												: props.service[
														"sPaymentStatus"
												  ] === "Credit"
												? "PaymentReceived"
												: "PaymentFailed"
										} ${
											(props.service['sPaymentReceiver'] !== "Partner" || props.service['sPaymentReceiver'] === "Partner" && props?.service['refExternalServicePartner']?.id === 66) &&props.service["sPaymentMode"] ===
											"2_Step_Payment"
												? 
											props.service?.bCouponApplied && (props.service.fDiscountAmount + (props.service.fDiscountAmount * 0.18)) >= props.service.fAmountFirst ?
											"disabled"
											:
											""
												: "disabled"
										} ${
											props.service["urlPayment"] !== null && props.service["sPaymentStatus"] ===
											"Credit"
												? "disabled"
												: ""
										}
                     `}
									> */}
									<div
										className={`underlined-action ${
											
											props.service["sPaymentStatus"] ===
											null || props.service["urlPayment2"] == null
												? props.service[
														"urlPayment2"
												  ] !== null
													? "PaymentPending"
													: "NotSent"
												: props.service[
														"sPaymentStatus"
												  ] === "Credit"
												? "PaymentReceived"
												: "PaymentFailed"
										} ${
											props.service["sPaymentMode"] ===
											"2_Step_Payment"
												? 
												(props.service.fDiscountAmount + (props.service.fDiscountAmount * 0.18)) >= props.service.fAmountFirst?
											"disabled"
											:
											""
												: "disabled"
										} ${
											props.service["urlPayment2"] !== null && props.service["sPaymentStatus"] ===
											"Credit"
												? "disabled"
												: ""
										}
                     `}
									>
													{/* <small className="label-link">
														<label className="label-link">
															{(props.service["urlPayment2"] == null || props.service[
																"sPaymentStatus"
															] === null)
																? props.service[
																	"urlPayment2"
																] !== null
																	? "Payment Pending"
																	: "Not Sent"
																: props.service[
																	"sPaymentStatus"
																] === "Credit"
																	? "Payment Received"
																	: props.service[
																		"sPaymentStatus"
																	] === "Failed"
																		? "Payment Failed"
																		: "Payment Link Deactivated"}
														</label>
													</small> */}
													{/* <small className="label-link">
														<label className="label-link">
															{props.service["urlPayment"] !== null && props.service["sPaymentStatus"] === "Payment Link Deactivated"
																? "Payment Link Deactivated"
																: props?.stateAuditLog?.some(
																	item => item.refCurrentState === "Full Payment Received"
																)
																	? "Payment Received"
																	: (props.service["urlPayment"] == null || props.service["sPaymentStatus"] === null)
																		? props.service["urlPayment"] !== null
																			? "Payment Pending"
																			: "Not Sent"
																		: props.service["sPaymentStatus"] === "Credit"
																			? "Payment Received"
																			: props.service["sPaymentStatus"] === "Failed"
																				? "Payment Failed"
																				: "Not Sent"}
														</label>
													</small> */}
													<small className="label-link">
														<label className="label-link">
															{props.service["urlPayment"] !== null && props.service["sPaymentStatus"] === "Payment Link Deactivated"
																? "Payment Link Deactivated"
																: props?.stateAuditLog?.some(
																	item => item.refCurrentState === "Full Payment Received"
																)
																	? "Payment Received"
																	: (props.service["urlPayment"] == null || props.service["sPaymentStatus"] === null)
																		? props.service["urlPayment"] !== null
																			? "Payment Pending"
																			: "Not Sent"
																		: props.service["sPaymentStatus"] === "Credit"
																			? "Payment Received"
																			: props.service["sPaymentStatus"] === "Failed"
																				? "Payment Failed"
																				: "Not Sent"}
														</label>
													</small>

									</div>
									
									<div style={{width:"180px"}}>
										{
											// props?.service?.urlPayment && !props.service.statusArray[8] ? (
											props?.service?.urlPayment && (props?.service?.refCurrentState?.sServiceState !== "Delivered" && props?.service?.refCurrentState?.sServiceState !== "Cancelled" && props?.service?.refCurrentState?.sServiceState !== "Full Payment Received") ? (
												<div style={{display: "flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
													<img
															alt="copy"
															title="Copy Payment Link"
															src={copysvg}
															height={"20px"}
															width={"16px"}
															className="con-cursor-pointer conv-mr13 conv-ml10"
															onClick={(e) => {
																e.preventDefault();
																
																if(props?.service?.urlPayment){
																	copyToClipboard(props?.service?.urlPayment);
																	toast(`Payment Link Copied!`, {
																		autoClose: 5000,
																		type: toast.TYPE.SUCCESS,
																	});
																}else{
																	toast(`No payment link found`, {
																		autoClose: 5000,
																		type: toast.TYPE.ERROR, // Use ERROR instead of SUCCESS
																	});
																}
															}}
														/>
														{/* <small style={{color:"#76287C", textAlign:"center"}}>(copy payment link)</small> */}
												</div>
											): ""
										}
									</div>
								</div>
							</div>

							
							{/* <label
								class={`container1 ${props.service.statusArray[5]}`}
							>
								Full Payment Requested
								<input
									name="requestFullPayments"
									onClick={(f) =>
										props.service.statusArray[5] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									type="checkbox"
								></input>
								<span
									name="requestFullPayments"
									onClick={(f) =>
										props.service.statusArray[5] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									class={`checkmark ${props.service.statusArray[5]}`}
								></span>
							</label>
							<label
								class={`container1 ${props.service.statusArray[6]}`}
							>
								Full Payment Received
								<input
									name="fullPaymentReceived"
									onClick={(f) =>
										props.service.statusArray[6] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									type="checkbox"
								></input>
								<span
									name="fullPaymentReceived"
									onClick={(f) =>
										props.service.statusArray[6] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									class={`checkmark ${props.service.statusArray[6]}`}
								></span>
							</label> */}
							<label
								class={`container1 ${props.service.statusArray[8]}`}
							>
								Delivered
								<input
									name="delivered"
									onClick={(f) =>
										props.service.statusArray[8] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									type="checkbox"
								></input>
								<span
									name="delivered"
									onClick={(f) =>
										props.service.statusArray[8] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									class={`checkmark ${props.service.statusArray[8]}`}
								></span>
							</label>
							{
								props.service["refCurrentState"]["sServiceState"] 
								=== "Cancelled"?
								(
									<label
										class={`container1 ${props.service.statusArray[9]}`}
									>
										Cancelled
										<input
											name="cancelled"
											type="checkbox"
										></input>
										<span
											name="cancelled"
											class={`checkmark ${props.service.statusArray[9]}`}
										></span>
									</label>
								):
								(
									<label
										class={`container1 ${props.service.statusArray[9]}`}
									>
										Cancelled
										<input
											name="cancelled"
											onClick={(f) =>
												props.handleClick(f, props.service)
											}
											type="checkbox"
										></input>
										<span
											name="cancelled"
											onClick={(f) =>
												props.handleClick(f, props.service)
											}
											class={`checkmark ${props.service.statusArray[9]}`}
										></span>
									</label>
								)
							}

							<div class="payment-links"> 
								<div className={`underlined-action  
									${
										props.service["refCurrentState"]["sServiceState"]
										==="Delivered"? "disabled": ""
									}`}
									onClick={(f) =>
										props.toggleRefundModal(props.service)
									}
								>
									<span className="label-link">{props.service["bRefund"]===true
										? "View Refund Details"
										: "Add Refund Details"}
									</span>
									
								</div>
							</div>

							<label
								class={`container1 ${props.service["bRefund"]===true ? "status-reached" : ""} ${
									props.service["refCurrentState"]["sServiceState"]
									==="Delivered"? "disable": ""
								}`}
							>
								Refunded
								<input
									name="refunded"
									onClick={(f) =>
										props.service.statusArray[10] ===
										"disable"
											? ""
											: props.toggleRefundModal(props.service)
									}
									type="checkbox"
								></input>
								<span
									name="refunded"
									onClick={(f) =>
										props.service.statusArray[10] ===
										"disable"
											? ""
											: props.toggleRefundModal(props.service)
									}
									class={`checkmark ${props.service["bRefund"]===true ? "status-reached" : ""} 
									${
										props.service["refCurrentState"]["sServiceState"]
										==="Delivered"? "disable": ""
									}`}
								></span>
							</label>
						</div>

						<ConfirmationModal
							message={props.message}
							isOpen={props.isOpenConfirmation}
							toggleModal={props.toggleConfirmationModal}
							changeState={props.changeState}
						/>
						<NeftModal
							isDisabled={
								props.service["refCurrentState"][
									"sServiceState"
								] === "Full Payment Received"
									? "disable"
									: ""
							}
							isOpen={props.isNeftModalOpen}
							toggleModal={props.toggleNeftModal}
							neftDetails={props.neftDetails}
							onInputChange={props.onNeftDetailsChanged}
							onSaveNeftDetails={props.onSaveNeftDetails}
							showSendNeftDetailsModal={
								props.showSendNeftDetailsModal
							}
							setShowSendNeftDetailsModal={
								props.setShowSendNeftDetailsModal
							}
							nResourceInstanceId={
								props.service.nResourceInstanceId
							}
						/>

						<RefundModal
							isDisabled={
								props.service["refCurrentState"]["sServiceState"] === "Delivered"?
								"disable": ""
							}
							service={props.service}
							isOpen={props.isRefundModalOpen}
							toggleModal={props.toggleRefundModal}
							refundDetails={props.refundDetails}
							onInputChange={props.onRefundDetailsChanged}
							onSaveRefundDetails={props.onSaveRefundDetails}
							nResourceInstanceId={props.service.nResourceInstanceId}
							isLoading={props.isLoadingRefund}
							cancellationReasonDropdownOptions={props.cancellationReasonDropdownOptions}
							onSelectCancellationReasonforRefund={props.onSelectCancellationReasonforRefund}
							selectedCancellationReasonforRefund={props.selectedCancellationReasonforRefund}
							enableOtherDescriptionTextboxforRefund={props.enableOtherDescriptionTextboxforRefund}
							cancellationReasonOtherDescriptionforRefund={props.cancellationReasonOtherDescriptionforRefund}
							onChangeCancellationReasonOtherDescriptionforRefund={props.onChangeCancellationReasonOtherDescriptionforRefund}
						/>
                         <StateChangeLogModalSPM
                            isOpen={props.showStatusChangeLogModal}
                            toggleModal={props.toggleStatusChangeLogModal}
                            stateAuditLog={props.stateAuditLog}
                        /> 

					</div>
				) : (
					""
				)}
              <div>       
                </div>
			   </div>
               
			  
			 <div className="col-8">
			   
			 <div className="status-column">
								{/* <div>	 
									<button
										type="button"
										className="close"
										aria-label="Close"
										onClick={props.toggleModal}
									>
										<X
											style={{ pointerEvents: "none" }}
											color="white"
										/>
									</button>
								</div> */}
								<span className="spled-info-title">Status Log</span>
								<div style={{ padding: "20px" }}>
									<div
										style={{
											overflowY: "scroll",
											height: "295px",
											marginTop: "20px",
											paddingLeft: 0,
											paddingRight: "40px",
										}}
									>
										{renderStateChangeAuditLog()}
									</div>
								</div>
							</div>
			   
			   </div>
			   


			</div>
		</div>
			</ModalContent>
		</Modal>  
	);

}
